import * as L from 'leaflet';
import { ControllerPolylineDecorator } from '../models/manager-leaflet.model';

export function animatePolylineDecorator(
  decorator: L.PolylineDecorator,
  map: L.Map,
  originalPatterns: any[],
  options?: {
    speed?: number;
    maxZoom?: number;
    fps?: number;
  }
): ControllerPolylineDecorator {
  let currentOffset = 0;
  let animationId: number;
  let lastTime = 0;
  let isPaused = false;

  const speed = options?.speed ?? 0.5;
  const maxZoom = options?.maxZoom ?? 15;
  const targetFPS = options?.fps ?? 30;
  const frameInterval = 1000 / targetFPS;

  // Definir el tipo para la configuración del patrón
  interface PatternConfig {
    offset: number;
    repeat: number;
    endOffset?: number;
    symbol: any;
  }

  // Guardar la configuración original de cada patrón
  const originalConfigs: PatternConfig[] = originalPatterns.map(
    (pattern: any) => ({
      offset: pattern.offset || 0,
      repeat: pattern.repeat || 20,
      endOffset: pattern.endOffset,
      symbol: pattern.symbol,
    })
  );

  function animate(currentTime: number) {
    // Control de FPS
    if (currentTime - lastTime < frameInterval) {
      animationId = requestAnimationFrame(animate);
      return;
    }
    lastTime = currentTime;

    // ACTIVAR SI EMPIEZA A LAGEAR A MÁS ZOOM LA ANIMACIÓN
    // Pausar animación si el zoom es muy alto
    // const currentZoom = map.getZoom();
    // if (currentZoom > maxZoom) {
    //   animationId = requestAnimationFrame(animate);
    //   return;
    // }

    currentOffset += speed;

    // Crear nuevos patrones manteniendo la configuración original pero animando el offset
    const animatedPatterns = originalConfigs.map((config: PatternConfig) => {
      const animatedOffset =
        (config.offset + currentOffset) % (config.repeat || 20);
      return {
        offset: animatedOffset,
        repeat: config.repeat,
        endOffset: config.endOffset,
        symbol: config.symbol,
      };
    });

    // Aplicar los patrones animados
    decorator.setPatterns(animatedPatterns);

    animationId = requestAnimationFrame(animate);
  }

  // Iniciar animación
  animationId = requestAnimationFrame(animate);
  isPaused = false;

  // Retornar función para detener la animación
  return {
    stop: () => {
      if (animationId) {
        cancelAnimationFrame(animationId);
        animationId = 0;
      }
      isPaused = false;
    },
    pause: () => {
      if (animationId) {
        cancelAnimationFrame(animationId);
        animationId = 0;
      }
      isPaused = true;
    },
    resume: () => {
      if (!animationId) {
        isPaused = false;
        animationId = requestAnimationFrame(animate);
      }
    },
    destroy: () => {
      if (animationId) {
        cancelAnimationFrame(animationId);
        animationId = 0;
      }
      isPaused = false;
      // Restaurar patrones originales para limpiar cualquier estado de animación
      decorator.setPatterns(originalPatterns);
    },
  };
}
